module.exports = __webpack_public_path__ + "img/statu-end.6777a687.png";